const API_URL_CONSTANTS = {
  ALL_BUILDINGS: "/buildings",
  FLATS: "/flat/building",
  DEVICES: "/device/flat",
  DASHBOARD_METRICS: "/filter/lineBarGraph",
  SIGNIN: "/user/signIn",
  SINGUP: "/user/signUp",
};

export default API_URL_CONSTANTS;
